// Certificate sharing helpers — build share-channel URLs for an ILFAL credential.
import { toast } from "sonner";

export function verifyUrl(verificationId) {
  return `${window.location.origin}/verify/${verificationId}`;
}

export function pdfUrl(verificationId) {
  return `${process.env.REACT_APP_BACKEND_URL}/api/verify/${verificationId}/download`;
}

const certName = (level) =>
  `ILFAL ${level.charAt(0).toUpperCase() + level.slice(1)} — AI Security Certificate`;

// LinkedIn "Add to profile" deep link.
export function linkedInAddUrl(cert) {
  const issued = new Date(cert.issued_at);
  const params = new URLSearchParams({
    startTask: "CERTIFICATION_NAME",
    name: certName(cert.level),
    organizationName: "ILFAL",
    issueYear: String(issued.getFullYear()),
    issueMonth: String(issued.getMonth() + 1),
    certUrl: verifyUrl(cert.verification_id),
    certId: cert.verification_id,
  });
  return `https://www.linkedin.com/profile/add?${params.toString()}`;
}

export function twitterShareUrl(cert) {
  const text = `I just earned the ${certName(cert.level)} 🛡️ — hands-on offensive & defensive AI security training. Verify it:`;
  const params = new URLSearchParams({ text, url: verifyUrl(cert.verification_id) });
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export async function copyVerifyLink(verificationId) {
  try {
    await navigator.clipboard.writeText(verifyUrl(verificationId));
    toast.success("Verification link copied");
  } catch {
    toast.error("Could not copy link");
  }
}

export function openShare(url) {
  window.open(url, "_blank", "noopener,noreferrer,width=720,height=720");
}
